module.exports = __webpack_public_path__ + "img/AAK_logo_RGB_Blå.c9b8b51e.svg";